var EquipmentsTypeSelectModule = /** @class */ (function () {
    function EquipmentsTypeSelectModule() {
    }
    return EquipmentsTypeSelectModule;
}());
export { EquipmentsTypeSelectModule };
